import React, { useContext, useRef, useEffect } from 'react';
import { Button, Flex, Text, Input, Spinner } from "@chakra-ui/react";
import { PayRentPropTypes } from "../PayRentPropTypes";
import { localisable } from "../../../generic/localisable";
import { commonInputStyleProps, emailFormButtonProps, payRentMainContainerProps, payRentMoveInContainerWidth } from "../constants";
import { useState } from 'react';
import { RenderBalanceDetailsModal, renderAmountRadioGroup, renderCardRadioButtonSelection, renderDropDown, renderExistingCardDetails, displayLoader, errorContainer, renderEnableAutoPayCheckbox } from "../Utils";
import { formatBalance } from "../../../utils/constant";
import { HOSTED_FORM_ID } from '../../SyrapayHostedForm/Constants';
import { getIndivCookie } from '../../../utils/auth';
import SyrapayHostedForm from 'components/SyrapayHostedForm/SyrapayHostedForm';
import { PaymentContext } from 'components/context/PaymentContext';
import { Form } from 'react-final-form'
import {
    fetchAuthKeyCall,
    handleSurchargeOrDiscountCalculatorCall,
    handleFormSubmitCall,
    existingCardPaymentCall,
    createTenantCall
} from '../apis/paymentApis';
import { FacilityContext } from 'components/context';
import { Link } from 'gatsby-link';
import { navigateTo } from '../../../utils/routeHelpers';

export const PayRentSyrapay = ({
    cardList,
    existingCardDetails,
    makePaymentHandler,
    logOffHandler,
    Balance,
    UnpaidAr,
    LastPaymentAmount,
    LastPaymentOn,
    shallRenderCardIcons = true,
    IsAutoPaymentsEnabled,
    IsOptingOutAutoPaymentRestricted,
    IsAutoPaymentsForced,
    PreferredPaymentMethod,
    usingInMoveIn = false,
    moveInConfigs,
    confirmationPageData,
}: PayRentPropTypes.ICombinedPayRentProps) => {
    const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
    const [cardOpted, setCardOpted] = useState((Object.keys(existingCardDetails).length > 0 && existingCardDetails.CCNumber)? 'existingCard' : 'newCard');
    const [amountType, setAmountType] = useState(Balance < 0 ? 'otherAmount' : 'balanceDue');
    const [amount, setAmount] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const [totalAmount, setTotalAmount] = useState(Balance || 0);
    const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
    const [loader, showLoader] = useState(false);
    const [isPaymentButtonDisabled, setIsPaymentButtonDisabled] = useState(cardOpted === 'newCard' ? true : false);
    const [showHostedForm, setShowHostedForm] = useState(false);
    const [authKey, setAuthKey] = useState('');
    const cToken = getIndivCookie('cToken');
    const paymentContext = useContext(PaymentContext);
    const facilityContext = useContext<any>(FacilityContext);
    const tempTenantToken = useRef<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [isPaymentCancelled, setIsPaymentCancelled] = useState(false);
    const [paymentErrorResponse, setPaymentErrorResponse] = useState({});
    const [signUpForAutopaySelection, setSignUpForAutopaySelection] = useState(IsAutoPaymentsEnabled);
    const [isSurchargeOrDiscount, setIsSurchargeOrDiscount] = useState(false);


    const handleSurchargeOrDiscountCalculator = async (amount: number, paymentMethodId: number) => {
        await handleSurchargeOrDiscountCalculatorCall(amount || 0, paymentMethodId, setIsPaymentButtonDisabled, setTotalPaymentAmount);
        setIsPaymentButtonDisabled(false);
        setIsLoading(false);
    };

    useEffect(() => {
        if (cToken&& cardOpted==="existingCard" && totalAmount>0) {
            const findSurcharge = async () => {
                setIsLoading(true);
                await handleSurchargeOrDiscountCalculator(totalAmount, PreferredPaymentMethod || 0);
            }
            findSurcharge();
        }
        if (PreferredPaymentMethod && cardOpted==="existingCard") {
            const preferredPaymentMethodIndex = cardList.findIndex(obj => obj.PayTypeID === PreferredPaymentMethod)
            setIsSurchargeOrDiscount(cardList[preferredPaymentMethodIndex].PayChargeEnabled || false)
            setSelectedPaymentMode(PreferredPaymentMethod.toString())
        }

    }, []);

    const fetchAuthKey = async () => {
        await fetchAuthKeyCall(totalPaymentAmount, cToken, paymentContext, setAuthKey, setShowHostedForm)
    }

    const existingCardPayment = async () => {
        await existingCardPaymentCall(
            existingCardDetails,
            // totalAmount,
            totalPaymentAmount,
            selectedPaymentMode || PreferredPaymentMethod?.toString() || '',
            cToken,
            IsAutoPaymentsEnabled,
            usingInMoveIn,
            moveInConfigs?.unitTypeID,
            facilityContext?.datoCmsFacilityDetails?.facilityName,
            moveInConfigs?.type,
            moveInConfigs?.moveInDate || '',
            setPaymentErrorResponse,
            signUpForAutopaySelection,
        )
        showLoader(false);
    };

    const fetchNewTenantAuthKey = async () => {
        const cTempToken = await createTenantCall(moveInConfigs);
        tempTenantToken.current = cTempToken
        await fetchAuthKeyCall(totalPaymentAmount, cTempToken, paymentContext, setAuthKey, setShowHostedForm)
    };


    const renderButtonSection = () => {
        return (
            <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                <Button
                    {...emailFormButtonProps}
                    bg='brand.tertiary'
                    minW={{ base: '100%', sm: '204px' }}
                    isDisabled={isPaymentButtonDisabled || totalAmount <= 0 || selectedPaymentMode === ""}
                    type='submit'
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.makePayment}</Text>
                </Button>
                <Button
                    {...emailFormButtonProps}
                    onClick={() => logOffHandler()}
                    bg='brand.tertiary'
                    minW={{ base: '100%', sm: '204px' }}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.logOff}</Text>
                </Button>
            </Flex>
        )
    };

    const renderMoveInButtonSection = () => {
        return (
            <Flex>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}  >
                    <Button
                        {...emailFormButtonProps}
                        bg='brand.lightTertiary'
                        minW={{ base: '100%', sm: '204px' }}
                        onClick={() => navigateTo('confirmation', 'view-rates', 'navigate', confirmationPageData)}
                    >
                        <Text textStyle='buttonSmall' color='brand.secondary' >{localisable.goBack}</Text>
                    </Button>
                    <Button
                        {...emailFormButtonProps}
                        isDisabled={isPaymentButtonDisabled || totalAmount <= 0 || selectedPaymentMode === ""}
                        bg='brand.lightTertiary'
                        minW={{ base: '100%', sm: '280px' }}
                        type='submit'
                    >
                        <Text textStyle='buttonSmall' color='brand.secondary' >{
                            moveInConfigs.type === 'reserve' ? localisable.reserveBtnLabel : localisable.moveBtnLabel
                        }</Text>
                    </Button>
                    {
                        cToken && <Button
                            {...emailFormButtonProps}
                            onClick={() => logOffHandler()}
                            bg='brand.lightTertiary'
                            minW={{ base: '100%', sm: '204px' }}
                        >
                            <Text textStyle='buttonSmall' color='brand.secondary' >{localisable.logOff}</Text>
                        </Button>
                    }
                </Flex>
            </Flex >
        )
    };

    const renderTotalAmountSection = () => {
        return <Flex>
            {
                (totalPaymentAmount && totalPaymentAmount !== Number(totalAmount) && !(cardOpted === 'newCard' && selectedPaymentMode === '')) ? <Flex direction='column'>
                    <Text textStyle='subtitle' fontStyle='italic'>{(totalPaymentAmount > Number(totalAmount)) ? localisable.surcharge : localisable.discount}: {formatBalance(totalPaymentAmount - Number(totalAmount))}</Text>
                    <Text textStyle='subtitle' fontStyle='italic'>{localisable.totalAmount}: {formatBalance(totalPaymentAmount)}</Text>
                </Flex> : <></>
            }
        </Flex>
    };

    const renderMoveInAmountSection = () => {
        return (
            <Flex direction={'column'}>
                <Text textStyle={'body1'}>
                    {moveInConfigs.type === 'reserve'
                        ? localisable.reserveAmtLabel
                        : localisable.moveAmtLabel}
                    *
                </Text>
                <Input {...commonInputStyleProps} value={Balance} isReadOnly w={{ base: '100%', sm: '318px' }} />
            </Flex>
        );
    };

    const paymentCancellationHandler = () => {
        setShowHostedForm(false);
        setIsPaymentButtonDisabled(false);
        showLoader(false);
        setIsPaymentCancelled(true);
    };


    const handleFormSubmit = async (
        otherResponse: any
    ) => {
        await handleFormSubmitCall(otherResponse,
            cardList,
            // totalAmount,
            totalPaymentAmount,
            selectedPaymentMode,
            cToken || tempTenantToken.current,
            usingInMoveIn,
            moveInConfigs?.unitTypeID,
            facilityContext?.datoCmsFacilityDetails?.facilityName,
            moveInConfigs?.type,
            moveInConfigs?.moveInDate || '',
            setPaymentErrorResponse,
            signUpForAutopaySelection,
        )
    }


    const paymentOnFormSubmit = async () => {
        if (cardOpted === 'newCard') {
            setIsPaymentButtonDisabled(true);
            setIsPaymentCancelled(false);
            await fetchAuthKey()
        } else {
            existingCardPayment()
        }
    };

    const moveInOnFormSubmit = async () => {
        if (cardOpted === 'newCard') {
            setIsPaymentButtonDisabled(true);
            setIsPaymentCancelled(false);
            if (cToken) {
                fetchAuthKey();
            } else {
                fetchNewTenantAuthKey();
            }
        } else {
            existingCardPayment()
        }
    };

    return (
        <Form
            onSubmit={async () => {
                setPaymentErrorResponse({});
                showLoader(true);
                if (!usingInMoveIn) {
                    paymentOnFormSubmit()
                } else {
                    moveInOnFormSubmit();
                }
            }}
            render={({ handleSubmit }) => {
                return <form
                    id={HOSTED_FORM_ID}
                    onSubmit={handleSubmit}
                >
                    <Flex
                        {...payRentMainContainerProps}
                        width={usingInMoveIn ? { ...payRentMoveInContainerWidth } : ''}
                    >
                        <Flex direction='column' w='100%' padding={{ sm: '0px 90px' }} gap='32px'>
                            <Text textStyle='h2' borderBottom={'1px solid'} paddingBottom={'32px'}>{localisable.payment}</Text>
                            {(loader || isLoading) && displayLoader()}
                            {!!Object.keys(paymentErrorResponse).length && errorContainer(paymentErrorResponse)}
                            <Flex direction='column' gap='24px'>
                                {(cardOpted === 'newCard')
                                    && renderDropDown(false, undefined, cardList, shallRenderCardIcons = false, selectedPaymentMode,
                                        setSelectedPaymentMode, totalAmount, setIsLoading, handleSurchargeOrDiscountCalculator, setIsSurchargeOrDiscount)}
                                {usingInMoveIn && renderMoveInAmountSection()}
                                {!usingInMoveIn && renderAmountRadioGroup(false, amountType, setAmountType, Balance, setTotalAmount, amount, setAmount,
                                    setModalOpen, selectedPaymentMode, undefined, undefined, setIsLoading, PreferredPaymentMethod || 0, handleSurchargeOrDiscountCalculator,
                                    isSurchargeOrDiscount, setIsPaymentButtonDisabled, setTotalPaymentAmount)}
                                {!isLoading &&totalAmount !==0 && renderTotalAmountSection()}
                                {Object.keys(existingCardDetails).length > 0 && renderCardRadioButtonSelection(cardOpted, setCardOpted,
                                    totalAmount, setSelectedPaymentMode, setIsLoading, handleSurchargeOrDiscountCalculator, PreferredPaymentMethod, existingCardDetails)}
                                {(cardOpted === 'existingCard') && renderExistingCardDetails(existingCardDetails)}
                                {!usingInMoveIn && renderEnableAutoPayCheckbox(localisable.enableAutopay, IsAutoPaymentsForced, IsOptingOutAutoPaymentRestricted, IsAutoPaymentsEnabled, setSignUpForAutopaySelection)}
                                {
                                    usingInMoveIn ?
                                        renderMoveInButtonSection() :
                                        renderButtonSection()
                                }
                                <Flex justifyContent={'center'} gap={'8px'}>
                                    <Link to={'/privacy-policy'} target='_blank'
                                    >
                                        <Text textStyle='body1'>
                                            {localisable.privacyPolicy}
                                        </Text>
                                    </Link>
                                    <Text>|</Text>
                                    <Link to={'/terms-of-use'} target='_blank'
                                    >
                                        <Text textStyle='body1'>
                                            {localisable.termsAndConditions}
                                        </Text>
                                    </Link>
                                </Flex>
                            </Flex>
                        </Flex>
                        {(isModalOpen && !usingInMoveIn) && <RenderBalanceDetailsModal
                            Balance={Balance}
                            UnpaidAr={UnpaidAr}
                            LastPaymentAmount={LastPaymentAmount}
                            LastPaymentOn={LastPaymentOn}
                            isModalOpen={isModalOpen}
                            setModalOpen={setModalOpen}
                        />}
                        {
                            cardOpted === 'newCard' && showHostedForm && !isPaymentCancelled ?
                                <SyrapayHostedForm
                                    amount={`${totalPaymentAmount}`}
                                    shouldSaveCard={false}
                                    authKey={authKey}
                                    hostedFormSubmitHandler={handleFormSubmit}
                                    paymentCancellationHandler={paymentCancellationHandler}
                                />
                                : <></>
                        }
                    </Flex >
                </form>
            }}
        >
        </Form>
    )
};